import { IconName } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { PropsWithChildren, createContext, useContext, useState } from 'react';

type BreadcrumbLink = {
  label: string;
  url: string;
  iconName: IconName;
};

type BreadcrumbContext = BreadcrumbLink[];
type SetBreadcrumbContext = (payload: BreadcrumbContext) => void;

const PageBreadcrumbContext = createContext<BreadcrumbContext>([]);
const SetPageBreadcrumbContext = createContext<SetBreadcrumbContext>(() => {});

export function PageBreadcrumbContextProvider(
  props: Readonly<PropsWithChildren>,
): React.JSX.Element {
  const { children } = props;

  const [breadcrumb, setBreadcrumb] = useState<BreadcrumbContext>([]);

  return (
    <PageBreadcrumbContext.Provider value={breadcrumb}>
      <SetPageBreadcrumbContext.Provider value={setBreadcrumb}>
        {children}
      </SetPageBreadcrumbContext.Provider>
    </PageBreadcrumbContext.Provider>
  );
}

export function usePageBreadcrumbContext(): BreadcrumbContext {
  return useContext(PageBreadcrumbContext);
}

export function useSetPageBreadcrumbContext(): SetBreadcrumbContext {
  return useContext(SetPageBreadcrumbContext);
}
